<template>
    <div class="main">
        <c-panel :title="edit ? 'EDITAR PRODUTO' : 'NOVO PRODUTO'" titleIcon="fas fa-box">
            <div v-if="edit && !carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Código" prop="codigo" :rules="[$requiredBlur]">
                            <el-input v-model="dados.codigo" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Unidade de medida" prop="unidade_medida" :rules="[$requiredChange]">
                            <el-select v-model="dados.unidade_medida" filterable placeholder="Selecione" style="width:100%;">
                                <el-option v-for="u in unidades" :key="u" :label="u" :value="u"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Grupo">
                            <el-select v-model="dados.grupo_id" filterable clearable placeholder="Selecione o grupo" style="width:100%;">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3">
                        <el-form-item label="Controla lote?">
                            <el-select v-model="dados.controla_lote" style="width:100%;">
                                <el-option :value="true" label="SIM"></el-option>
                                <el-option :value="false" label="NÃO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width:100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição">
                            <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/almox-produto"><el-button class="u-mr-5">VOLTAR</el-button></router-link>
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        edit: false,
        carregado: false,
        grupos: [],
        unidades: ['UN', 'KG', 'G', 'L', 'ML', 'M', 'CX', 'PCT', 'FD', 'SC', 'DZ', 'KIT'],
        dados: {
            codigo: '',
            nome: '',
            unidade_medida: '',
            grupo_id: '',
            controla_lote: false,
            descricao: '',
            situacao: true
        }
    }),
    mounted () {
        this.carregarGrupos()
        if (this.$route.params.id) {
            this.edit = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/almox-produto/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                this.dados = {
                    codigo: reg.codigo || '',
                    nome: reg.nome || '',
                    unidade_medida: reg.unidade_medida || '',
                    grupo_id: reg.grupo_id || '',
                    controla_lote: !!reg.controla_lote,
                    descricao: reg.descricao || '',
                    situacao: reg.situacao !== false
                }
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.edit
                    ? `${this.baseUrl()}/api/almox-produto/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/almox-produto/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/almox-produto')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
